<script setup lang="ts">
import type {ActionTypes} from '@/types/';

type CalloutButtonType = {
  tag?: 'NuxtLink' | 'button';
  type?: 'button' | 'submit' | 'reset' | undefined;
  primary?: boolean;
  secondary?: boolean;
  cta?: boolean;
  analyticsAction?: ActionTypes | undefined;
  analyticsTarget?: string | undefined;
};

const props = withDefaults(defineProps<CalloutButtonType>(), {
  tag: 'NuxtLink',
  type: 'button',
  analyticsAction: undefined,
  analyticsTarget: undefined,
  inActive: false,
});

const buttonType = computed(() => {
  return props.cta ? 'cta' : props.secondary ? 'secondary' : 'primary';
});
</script>

<template>
  <button v-if="tag === 'button'" :type="type" class="the-button" :class="buttonType">
    <slot />
  </button>
  <TheNuxtLink v-else to="" v-bind="$attrs" class="the-button" :class="buttonType" :analytics-target="props.analyticsTarget">
    <slot />
  </TheNuxtLink>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
$border-width: 2px;
button.the-button {
  font-size: 1.75rem;
  padding: 1.5rem 6rem;
  @include queries.for-size(ipadpro-portrait-down) {
    padding: 1.25rem 6rem;
  }
}

a.the-button {
  cursor: pointer;
  padding: 1.5rem 6rem;
  @include queries.for-size(ipadpro-portrait-down) {
    padding: 1.25rem 6rem;
  }
}

.the-button {
  border-radius: 100px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: clamp(1.1rem, 3vw, 1.75rem);
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.5s ease-out;

  @include queries.for-size(tablet-md) {
    font-size: 20px;
  }

  @include queries.for-size(phone) {
    font-size: 18px;
  }

  &.cta {
    background-image: linear-gradient(#ffffff, #ffffff);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 0% 100%;
    border-color: #ffffff;
    border-style: solid;
    border-width: $border-width;
    transition:
      background-size 0.5s,
      color 0.5s;

    &:hover {
      background-size: 100% 100%;
      color: black;
    }
  }

  &.primary {
    background-color: black;
    border-color: black;
    border-style: solid;
    border-width: $border-width;
    &:hover {
      background-color: white !important;
      color: black;
    }
  }

  &.secondary {
    background-color: black;
    border-color: black;
    border-style: solid;
    border-width: $border-width;
    &:hover {
      background-color: white !important;
      color: black;
    }
  }
}
</style>
